<script setup>
//import MessageBox from './SimpliaV2Components/MessageBox/MessageBox.vue';
//import MessageBox from './SimpliaV2Components/ViewportHeader/ViewportHeader.vue';
import MessageBox from './SimpliaV2Components/NewMessageBox/NewMessageBox.vue';

defineProps({
  ClientID: {
    type: String,
    required: true
  },
  viewportID: {
    type: String,
    required: true
  }

})
</script>


<template>
<div :id="'footer_'+viewportID" name="oxygen-footer">
  <MessageBox :viewportID="viewportID" :ClientID="ClientID"></MessageBox>
</div>
</template>
